module.exports = __webpack_public_path__ + "img/GT.ShallowFoundation.RaftFoundation.UnpiledRaft1-5m.871e54be.png";